<template>
    <portal-layout
        title="Appointment Not Found"
        :hide-notification="true"
    >
        <div class="flex flex-col items-center justify-center min-h-[calc(100vh-300px)]">
            <div class="text-center">
                <ExclamationCircleIcon class="w-16 h-16 mx-auto mb-4 text-red-600" />
                <h1 class="mb-2 text-2xl font-bold text-darkgray-800">Appointment Not Found</h1>
                <p class="mb-6 text-darkgray-800">We couldn't find the appointment you're looking for. It may have been cancelled or removed.</p>
                <ButtonComponent 
                text="Go Back to Appointments" 
                @click="backToAppointment"
                />
            </div>
        </div>
    </portal-layout>
</template>
  
<script setup lang="ts">
    import PortalLayout from '@/layouts/PortalLayout.vue';
    import ButtonComponent from '@/components/ButtonComponent.vue';
    import { ExclamationCircleIcon } from "@heroicons/vue/24/outline";
    import { useRouter } from 'vue-router';

    const router = useRouter();

    const backToAppointment = () => {
        window.location.replace('/appointment');
    };
</script>